import React, { useState, useEffect, useContext } from 'react';
import { getLinks, deleteLink, getLinkById } from '../api/api';
import LinkForm from '../components/LinkForm';
import { AuthContext } from '../context/AuthContext';
import '../index.css';
import './Users.css'; // Reuse Users CSS
import Table from '../components/common/Table';
import Header from '../components/common/Header';
import Search from '../components/common/Search';
import Button from '../components/common/Button';
import Error from '../components/common/Error';

const Links = () => {
    const [links, setLinks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [linkToEdit, setLinkToEdit] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const { userRole } = useContext(AuthContext);

    const canCreate = userRole === "Director";
    const canUpdate = userRole === "Director";
    const canDelete = userRole === "Director";
    const canRead = userRole === "Director" || userRole === "Navegador" || userRole === "Lector";

    useEffect(() => {
        const fetchLinks = async () => {
            setLoading(true);
            try {
                const linksData = await getLinks();
                setLinks(linksData);
            } catch (err) {
                setError(err.message || 'Error al cargar los links');
            } finally {
                setLoading(false);
            }
        };
        if (canRead) {
            fetchLinks();
        } else {
            setError("No tienes permisos para ver los links")
        }
    }, [canRead, userRole]);

    const handleCreate = () => {
        setLinkToEdit(null);
        setShowForm(true);
    };

    const handleEdit = async (id) => {
        try {
            const link = await getLinkById(id);
            if (!link || !link.id) {
                setError("El link no tiene un ID válido.");
                return;
            }
            setLinkToEdit(link);
            setShowForm(true);
        } catch (error) {
            setError(error.message || 'Error al cargar el link');
        }
    };

    const handleDelete = async (id) => {
        try {
            await deleteLink(id);
            setLinks(links.filter(link => link.id !== id));
        } catch (err) {
            setError(err.message || 'Error al eliminar el link');
        }
    };

    const handleCloseForm = () => {
        setShowForm(false);
        setLinkToEdit(null);
    }

    const handleLinkUpdated = (newLink) => {
        setLinks(links.map((link) => (link.id === newLink.id ? newLink : link)))
    }

    const handleLinkCreated = (newLink) => {
        setLinks([...links, newLink])
    }

    const filteredLinks = links.filter((link) => {
        const linkValues = Object.values(link).join('').toLowerCase();
        return linkValues.includes(searchTerm.toLowerCase());
    });

    if (loading) return <div>Cargando...</div>;
    if (error) return <Error error={error} />;

    const tableHeaders = ["Nombre", "URL", "Acompañamiento", "Acciones"];

    const truncateText = (text, maxLength) => {
        if (!text) return "";
        if (text.length > maxLength) {
            return text.substring(0, maxLength) + "...";
        }
        return text;
    };

    const renderLinkRow = (link) => {
        return [
            truncateText(link.text, 30),
            link.url ? <a href={link.url} target="_blank" rel="noopener noreferrer">{link.url}</a> : "No URL",
            link.accompaniment ? "Sí" : "No",
            [
                canUpdate && (
                    <Button
                        key={`edit-${link.id}`}
                        onClick={() => handleEdit(link.id)}
                    >
                        Editar
                    </Button>
                ),
                canDelete && (
                    <Button
                        key={`delete-${link.id}`}
                        onClick={() => handleDelete(link.id)}
                    >
                        Eliminar
                    </Button>
                ),
            ],
        ];
    };

    return (
        <div className='container'>
            <Header title="Gestión de Links" />
            <Search searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
            {canCreate && <Button onClick={handleCreate}>Crear Link</Button>}
            {showForm && <div className='container-form'><LinkForm onClose={handleCloseForm} link={linkToEdit} onLinkUpdated={handleLinkUpdated} onLinkCreated={handleLinkCreated} /></div>}
            <Table headers={tableHeaders} data={filteredLinks} renderRow={renderLinkRow} />
        </div>
    );
};

export default Links;
